module.exports = __webpack_public_path__ + "img/error-warning.15adc592.svg";